import React, { SVGProps } from 'react'
const SvgDownload = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill={props.fill || 'var(--color-cta)'} fillRule="nonzero">
      <path d="m12.75 14.19 4.72-4.72a.75.75 0 0 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 1.06-1.06l4.72 4.72V3a.75.75 0 0 1 1.5 0v11.19Z" />
      <path d="M4.75 19.942V17a.75.75 0 1 0-1.5 0v3.692c0 .415.336.75.75.75h16a.75.75 0 0 0 .75-.75V17a.75.75 0 1 0-1.5 0v2.942H4.75Z" />
    </g>
  </svg>
)
export default SvgDownload
